// Simple localStorage-backed progress tracker for the frontend
const KEY = 'gamify:progress_v1';

function defaultProgress() {
  return {
    quizzesTaken: 0,
    totalQuizScore: 0,
    bestQuizScore: 0,
    points: 0,
    gamesPlayed: 0,
    correctAnswers: 0,
    wrongAnswers: 0,
    badges: [],
    lastPlayed: null,
    dayStreak: 0,
    quizzes: []
  };
}

export function getProgress() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      const p = defaultProgress();
      saveProgress(p);
      return p;
    }
    return JSON.parse(raw);
  } catch (err) {
    console.warn('Failed to read progress', err);
    const p = defaultProgress();
    saveProgress(p);
    return p;
  }
}

export function saveProgress(p) {
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch (err) {
    console.warn('Failed to save progress', err);
  }
}

export function addPoints(n) {
  const p = getProgress();
  p.points = (p.points || 0) + n;
  p.lastPlayed = new Date().toISOString();
  saveProgress(p);
  return p;
}

export function recordQuestionResult({ game = 'generic', correct = false, points = 0 }) {
  const p = getProgress();
  p.gamesPlayed = (p.gamesPlayed || 0) + 1;
  if (correct) p.correctAnswers = (p.correctAnswers || 0) + 1;
  else p.wrongAnswers = (p.wrongAnswers || 0) + 1;
  if (points) p.points = (p.points || 0) + points;
  p.lastPlayed = new Date().toISOString();
  saveProgress(p);
  return p;
}

export function recordQuizResult(score) {
  const p = getProgress();
  p.quizzesTaken = (p.quizzesTaken || 0) + 1;
  p.totalQuizScore = (p.totalQuizScore || 0) + score;
  p.quizzes = p.quizzes || [];
  p.quizzes.push({ score, time: new Date().toISOString() });
  if (!p.bestQuizScore || score > p.bestQuizScore) p.bestQuizScore = score;
  p.lastPlayed = new Date().toISOString();
  saveProgress(p);
  return p;
}

export function awardBadge(id) {
  const p = getProgress();
  p.badges = p.badges || [];
  if (!p.badges.includes(id)) {
    p.badges.push(id);
    saveProgress(p);
  }
  return p;
}

export function hasBadge(id) {
  const p = getProgress();
  return p.badges && p.badges.includes(id);
}

export function resetProgress() {
  const p = defaultProgress();
  saveProgress(p);
  return p;
}

export default {
  getProgress,
  saveProgress,
  addPoints,
  recordQuestionResult,
  recordQuizResult,
  awardBadge,
  hasBadge,
  resetProgress
};
